module.exports = __webpack_public_path__ + "static/img/vision_track_blue.23aff6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vision_track_blue.png
// module id = NeUd
// module chunks = 1